import { makeMaster } from '~/utils/sfxEngine'

/**
 * 🎚️ One AudioContext for EVERYTHING (v1.87, per Javi's mobile pops):
 * music and sfx used to reach the speaker as two separate streams, and
 * the OS-level re-mix (plus occasional summed clipping) clicked on
 * phones. Now both route through one graph with a limiter master.
 */
let ctx: AudioContext | null = null
let master: AudioNode | null = null

export function audioBus(): { ctx: AudioContext, master: AudioNode } | null {
  if (typeof window === 'undefined') return null
  try {
    if (!ctx) {
      ctx = new AudioContext()
      master = makeMaster(ctx)
    }
    // A rejected resume() (e.g. a device error) is an unhandled promise
    // rejection otherwise — audio is never worth crashing over.
    // 📱 M6: anything but running, not just 'suspended' - WebKit reports
    // 'interrupted' after a phone call, Siri or a trip to the background.
    if (ctx.state !== 'running' && ctx.state !== 'closed') ctx.resume().catch(() => {})
    return { ctx, master: master! }
  } catch {
    return null
  }
}

/** 📱 M6: the app went to the background (true) or came back (false). The
 * context is only ever suspended or resumed here, never created: a title
 * that has not been tapped yet has none, and must not start one. */
export function holdAudioBus(held: boolean) {
  if (!ctx || ctx.state === 'closed') return
  if (held) {
    if (ctx.state === 'running') ctx.suspend().catch(() => {})
  } else if (ctx.state !== 'running') {
    ctx.resume().catch(() => {})
  }
}
